import React from "react"
import FieldRenderer from "./FieldRenderer"

export default function RenderItem({ item, ...props }) {
  const editable = props.editable || props.editing
  const mode = props.mode ?? "form"
  const density = props.density ?? "md"
  const showLabel = props.showLabel ?? true

  return (
    <FieldRenderer
      field={item}
      value={item.value}
      primitive={props.primitive}
      items={props.items}
      editable={editable}
      disabled={item.locked}
      showLabel={showLabel}
      mode={mode}
      density={density}
      embedded={props.embedded}
      minor={props.minor}
      callback={props.callback}
      activeOnly={props.activeOnly}
      allowNone={props.allowNone}
      local={props.local}
      primitiveList={props.primitiveList}
      selectionMode={props.selectionMode}
      ensurePresent={props.ensurePresent}
      types={props.types}
      referenceIds={props.referenceIds}
      onChange={props.onChange}
    />
  )
}
